export default {
  placeholder: 'Pesquisar negócio...',
};
